import { render, staticRenderFns } from "./EditCustomerModal.vue?vue&type=template&id=7170a4cf&"
import script from "./EditCustomerModal.vue?vue&type=script&lang=js&"
export * from "./EditCustomerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports